import { v4 as uuidv4 } from "uuid";

export const modalities = [
	{ id: uuidv4(), label: "Pay Rate" },
	{ id: uuidv4(), label: "Unpaid" },
	{ id: uuidv4(), label: "Draw Equivalent" },
	{ id: uuidv4(), label: "Working days proration" },
	{
		id: uuidv4(),
		label: "Last xQs",
		options: [
			{ label: "1Qs", id: uuidv4() },
			{ label: "2Qs", id: uuidv4() },
			{ label: "3Qs", id: uuidv4() },
			{ label: "4Qs", id: uuidv4() },
		],
	},
	{
		id: uuidv4(),
		label: "Flat",
		options: [
			{ label: "daily", id: uuidv4() },
			{ label: "weekly", id: uuidv4() },
			{ label: "BiWeekly", id: uuidv4() },
		],
	},
];
